import SEOHead, { faqSchema, organizationSchema, breadcrumbSchema } from "@/components/SEOHead";
import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";
import FaqBlock, { CtaBlock } from "@/components/FaqBlock";

const HELP_FAQS = [
  { q: "How do I create my first task?", a: "Sign up (free), then type a title in the 'Add a big task' input on the dashboard and press Enter. Add priority, due date, duration, and recurrence in the row below if you want." },
  { q: "How does the AI breakdown work?", a: "Hover any active task and click 'Break down' — or open the task in Focus mode and press B. Claude Sonnet 4.5 reads your title, priority, and optional description, and returns 4–6 short subtasks." },
  { q: "How do I add a description to a task?", a: "Click the pencil icon (Edit) on a task. A dialog opens with a description field. It auto-saves as you type, and the AI uses it for richer subtasks." },
  { q: "How do I install BreakItDown to my home screen?", a: "On iPhone: tap the Safari Share button → Add to Home Screen. On Android Chrome: tap the ⋮ menu → Install app. On desktop Chrome/Edge: click the install icon in the address bar, or open menu → Install BreakItDown. The installed PWA stays signed in for 60 days." },
  { q: "How do I share a task?", a: "Click the Share button on any task and toggle the switch. Copy the /share/<token> URL — anyone with it can view the task and its subtasks read-only. Revoke any time." },
  { q: "How do I enable the daily briefing?", a: "Open Settings (gear icon), toggle Notifications on, pick a time, and save. Grant notification permission when prompted. The service worker schedules the briefing — it fires even if the tab is closed (Chromium browsers)." },
  { q: "Why doesn't the briefing fire on Safari or Firefox?", a: "Those browsers don't yet support the Notification Triggers API. BreakItDown falls back to an in-tab scheduler — keep the tab open and it'll still fire." },
  { q: "What are the keyboard shortcuts?", a: "/ focuses the add-task input. B breaks down the focus task (or first task without subtasks). Space toggles the focus timer. Esc exits focus mode." },
  { q: "Is my data private?", a: "Yes. Each account's tasks are scoped by user_id and never visible to other accounts. Only public share links expose specific tasks, and only with the random token." },
  { q: "How do I reset the focus timer?", a: "In focus mode, click Reset. The timer returns to the task's configured duration." },
];

export default function HelpPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEOHead
        title="BreakItDown Help & Documentation"
        description="Help articles for BreakItDown: AI task breakdown, focus timer, install-to-home-screen, share links, daily briefing, keyboard shortcuts, and more."
        path="/help"
        schemas={[
          organizationSchema(),
          faqSchema(HELP_FAQS),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Help", path: "/help" },
          ]),
        ]}
      />
      <MarketingHeader />
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16 w-full">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500 mb-3">Help centre</p>
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
          Get the most out of BreakItDown.
        </h1>
        <p className="text-base text-zinc-600 mt-4">Short answers to the questions people ask most.</p>
        <FaqBlock faqs={HELP_FAQS} />
        <CtaBlock />
      </main>
      <MarketingFooter />
    </div>
  );
}
